import { v4 as uuidv4 } from "uuid";
import { replaceToken } from "./utils";

((Drupal, drupalSettings) => {
  const uid = drupalSettings.user?.uid || 0;

  /**
   * Build the storage key for sessionStorage
   * @param {string} wrapperId The wrapper ID
   * @returns {string} The storage key
   */
  function buildStorageKey(wrapperId) {
    return `analytics_tokens-video_view_id:${uid}:${wrapperId}`;
  }

  /**
   * Set the video view ID in browser storage
   * @param {string} uuid The value to save to storage
   * @param {string} wrapperId The wrapper ID
   */
  function saveToStorage(uuid, wrapperId) {
    try {
      sessionStorage.setItem(buildStorageKey(wrapperId), uuid);
    } catch (e) {
      console.warn("Could not save video_view_id to sessionStorage", e);
    }
  }

  /**
   * Replace person token tokens with the real value within drupalSettings object.
   * @param {string} token The video view id value
   * @param {object} settings DrupalSettings object
   */
  function replaceInDrupalSettings(token, settings = drupalSettings) {
    replaceToken(settings, "[analytics_token:video_view_id]", token);
  }

  /**
   * Create a promise to get the view ID.
   * @param {string} wrapperId The wrapper ID.
   * @returns {Promise} Promise for the view ID.
   */
  function getPromiseForVideoViewId(wrapperId) {
    return new Promise((resolve, reject) => {
      try {
        let uuid = null;

        // 🔹 Reuse existing value if found
        try {
          uuid = sessionStorage.getItem(buildStorageKey(wrapperId));
        } catch (e) {
          console.warn("Could not access sessionStorage", e);
        }

        if (!uuid) {
          // Generate new if none exists
          uuid = uuidv4();
          saveToStorage(uuid, wrapperId);
        }

        // ✅ Use the shared util
        replaceInDrupalSettings(uuid);
        resolve(uuid);
      } catch (error) {
        reject(error);
      }
    });
  }

  Drupal.behaviors.replaceVideoViewId = {
    attach: async function (context, settings) {
      const wrapperId = settings.analytics_tokens?.view_rule_id;
      if (!wrapperId) {
        return;
      }

      if (!settings.analytics_tokens.videoViewIdPromise) {
        settings.analytics_tokens.videoViewIdPromise =
          getPromiseForVideoViewId(wrapperId);
      }
      const viewId = await settings.analytics_tokens.videoViewIdPromise;
      replaceInDrupalSettings(viewId, settings);
    },
  };
})(Drupal, drupalSettings);
